import { oxgCreateUf, oxgRemoveUfsFromContainer } from "../../modules/user-feedback";
import { oxgOpenModal, oxgCloseModal, oxgFetchModal, oxgCloseModalAnimated, oxgCreateLoadingOverlay, oxgRemoveLoadingOverlay } from "../../modules/modals";
import { oxgSlugifyString, oxgSlugifyStringNoEndTrim } from "../../modules/strings";

/*
  #ANCHOR Request Password Reset Link
*/

window.oxgRequestPasswordResetLink = () => {
  oxgCreateLoadingOverlay()

  let $ = jQuery
  const email = $('#user-email').val()
  const removeAfterMailSent = $('.remove-after-mail-sent')
  const formHeader = $('#form-header')
  const headline = $('#headline')
  const headlineAltText = headline.attr('data-mail-sent-text')
  const feedback = $('#user-feedback')
  const feedbackText = $('#user-feedback-text')
  const feedbackIcon = $('#user-feedback-icon')

  console.log(ajax_obj.ajax_url)
  console.log(ajax_obj.nonce)
  console.log(email)

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress AJAX URL
    type: 'POST',
    data: {
      action: 'oxg_request_password_reset',
      email: email,
      security: ajax_obj.nonce // Send nonce for security
    },
    success: function(response) {
      oxgRemoveLoadingOverlay()
      feedbackText.text(response.data.message)
      feedback.removeClass('is-hidden tc-danger tc-success')
      feedback.addClass(response.data.class)
      feedbackIcon.removeClass('icon-i--circled icon-exclamation-mark--circled').addClass(response.data.icon)
      if(response.data.event == 'mail_sent') {
        removeAfterMailSent.remove()
        feedback.css('text-align', 'center')
        feedbackText.addClass('fs4 flash').removeClass('fs3')
        headline.text(headlineAltText)
        feedbackIcon.remove()
      }
    },
    error: function(response) {
      oxgRemoveLoadingOverlay()
    }
  });
}

/*
  #ANCHOR Set New Password
*/

window.oxgUserSetNewPassword = (feedbackText, icon, feedbackContainer)=> {
  oxgCreateLoadingOverlay()
  const newPassword = jQuery('#new-password').val();
  const securityToken = new URLSearchParams(window.location.search).get('token'); // Assuming the token is in the URL

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress AJAX URL
    type: 'POST',
    data: {
      action: 'oxg_set_new_password',
      new_password: newPassword,
      token: securityToken
    },
    success: function(response) {
      oxgRemoveLoadingOverlay()
      if(response.data.event == 'password_set' ) {
        window.open(window.location.origin + '/login?sb_docked=0&msg=' + response.data.message + '&msg_type=success', '_self')
      } else {
        // Not valid, token expired or token invalid
        feedbackContainer.classList.remove('tc-success', 'tc-info')
        feedbackContainer.classList.add('tc-danger')
        feedbackText.innerText = response.data.message
        icon.classList.remove('icon-32-exclamation-mark--circled', 'icon-32-checkmark')
        icon.classList.add('icon-32-exclamation-mark--circled')
      }
      console.log(response)
    },
    error: function(response) {
      oxgRemoveLoadingOverlay()
      console.log(response)
    }
  });
}

window.oxgAddRemoveTeamMembers = (modalId)=> {
  // Create Loading Animation
  oxgCreateLoadingOverlay();

  //get form
  let $ = jQuery
  var $form = $('#add-remove-team-members-form');
  var formData = $form.serializeArray();
  //add action and security token
  formData.push({ name: 'action', value: 'oxg_add_remove_team_members' });
  formData.push({ name: 'security', value: ajax_obj.nonce });

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_add_remove_team_members', // WordPress action hook to trigger the PHP function
        data: formData
    },
    success: function(response) { 
      let teamId = oxgUrlParams.get('team')
      window.open(window.location.origin + '/team?team=' + teamId + '&uf=' + response.data.message + '&ufmt=' + response.data.message_type, '_self')
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
      oxgRemoveLoadingOverlay(); //Remove Loading Animation
    }
  });
}

window.oxgEditUser = (modalId)=> {

  // Create Loading Animation
  oxgCreateLoadingOverlay();

  //get form
  let $ = jQuery
  var $form = $('#edit-user-form');
  var formData = $form.serializeArray();
  //add action and security token
  formData.push({ name: 'action', value: 'oxg_edit_user' });
  formData.push({ name: 'security', value: ajax_obj.nonce });

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_edit_user', // WordPress action hook to trigger the PHP function
        data: formData
    },
    success: function(response) { 
      //console.log('message', response.data.message)
      //console.log('data', response.data.data)
      //console.log('user_edited', response.data.user_edited)
      //console.log('user_teams', response.data.user_teams)
      //console.log('team_client_ids', response.data.team_client_ids)
      //console.log('teams_to_remove', response.data.teams_to_remove)
      window.open(window.location.origin + '/manage-users?uf=' + response.data.message + '&ufmt=' + response.data.message_type, '_self')
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
      oxgRemoveLoadingOverlay(); //Remove Loading Animation
    }
  });
}

window.oxgEditUserTeamRole = (modalId)=> {
  // Create Loading Animation
  oxgCreateLoadingOverlay();

  //get form
  let $ = jQuery
  var $form = $('#edit-user-team-role-form');
  var formData = $form.serializeArray();
  //add action and security token
  formData.push({ name: 'action', value: 'oxg_edit_user_team_role' });
  formData.push({ name: 'security', value: ajax_obj.nonce });

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_edit_user_team_role', // WordPress action hook to trigger the PHP function
        data: formData
    },
    success: function(response) { 
      //console.log('message', response.data.message)
      //console.log('user_edited', response.data.user_edited)
      //console.log('user_team_role', response.data.user_team_role)
      //console.log('data', response.data.data)
      let teamId = oxgUrlParams.get('team')
      window.open(window.location.origin + '/team?team=' + teamId + '&uf=' + response.data.message + '&ufmt=' + response.data.message_type, '_self')
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
      oxgRemoveLoadingOverlay(); //Remove Loading Animation
    }
  });
}

window.oxgRemoveUserFromTeam = (modalId)=> {
  // Create Loading Animation
  oxgCreateLoadingOverlay();

  //get form
  let $ = jQuery
  var $form = $('#remove-user-from-team-form');
  var formData = $form.serializeArray();
  //add action and security token
  formData.push({ name: 'action', value: 'oxg_remove_user_from_team' });
  formData.push({ name: 'security', value: ajax_obj.nonce });

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_remove_user_from_team', // WordPress action hook to trigger the PHP function
        data: formData
    },
    success: function(response) { 
      //console.log('message', response.data.message)
      //console.log('user_removed', response.data.user_removed)
      //console.log('team', response.data.team)
      //console.log('data', response.data.data)
      let teamId = oxgUrlParams.get('team')
      window.open(window.location.origin + '/team?team=' + teamId + '&uf=' + response.data.message + '&ufmt=' + response.data.message_type, '_self')
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
      oxgRemoveLoadingOverlay(); //Remove Loading Animation
    }
  });
}

window.oxgAfterNewTeamCreatedModalOpen = ()=> {
  setTimeout(function() {
    oxgCloseModalAnimated('ntcm');
    setTimeout(function() {
      window.open(window.location.origin + '/teams', '_self')
    }, 150)
  }, 1500)
}

window.oxgAddNewTeam = (modalId)=> {
  // Create Loading Animation
  oxgCreateLoadingOverlay();

  //get modal response container
  let modal = document.getElementById('oxg-modal-' + modalId)
  let modalResponseContainer = modal.querySelector('.modal-response-container')
  let nameField = modal.querySelector('#field-team-name')
  let slugField = modal.querySelector('#field-team-slug')

  //get form
  let $ = jQuery
  var $form = $('#add-new-team-form');
  var formData = $form.serializeArray();
  //add action and security token
  formData.push({ name: 'action', value: 'oxg_add_new_team' });
  formData.push({ name: 'security', value: ajax_obj.nonce });

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint (available in the admin context or frontend if localized)
    type: 'POST',
    data: {
        action: 'oxg_add_new_team', // WordPress action hook to trigger the PHP function
        data: formData
    },
    success: function(response) { 
      oxgRemoveLoadingOverlay();
      console.log(response)
      if(response.data.message_type == 'success') {
        oxgRemoveUfsFromContainer(modalResponseContainer)
        oxgCreateUf({
          format: 'box',
          icon: 'exclamation-mark--circled',
          style: 'success',
          message: response.data.message,
          messageDe: response.data.message,
          container: modalResponseContainer,
          classes: ['m-bottom', 'm-xs-top'],
          return: true,
        })
        let ntcmModal = oxgFetchModal('ntcm')
        oxgCloseModal(modalId)
        oxgOpenModal(ntcmModal, 'compact', 'oxgAfterNewTeamCreatedModalOpen')
      } else if (response.data.message == 'Duplicate team data') {
        // Response
        let returnValue = response.data.duplicate_team_data
        if ( returnValue.display_name == nameField.value && returnValue.team_slug == slugField.value) {
          // Name and Slug already taken
          oxgRemoveUfsFromContainer(modalResponseContainer)
          oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Team name and team slug already exist',
            messageDe: 'Team Name und Team Slug existieren bereits',
            container: modalResponseContainer,
            classes: ['m-bottom', 'm-xs-top'],
            return: true,
          })
        } else if ( returnValue.display_name == nameField.value ) {
          // Name already exists
          oxgRemoveUfsFromContainer(modalResponseContainer)
          oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Team name already exists',
            messageDe: 'Team Name existiert bereits',
            container: modalResponseContainer,
            classes: ['m-bottom', 'm-xs-top'],
            return: true,
          })
        } else if ( returnValue.team_slug == slugField.value ) {
          // Slug already exists
          oxgRemoveUfsFromContainer(modalResponseContainer)
          oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Team slug already exists',
            messageDe: 'Team Slug existiert bereits',
            container: modalResponseContainer,
            classes: ['m-bottom', 'm-xs-top'],
            return: true,
          })
        }
      } else if (response.data.message == 'Missing client id') {
        // Missing Client ID
        oxgRemoveUfsFromContainer(modalResponseContainer)
        oxgCreateUf({
          format: 'box',
          icon: 'exclamation-mark--circled',
          style: 'danger',
          message: 'Please select a client',
          messageDe: 'Bitte gib einen Client an',
          container: modalResponseContainer,
          classes: ['m-bottom', 'm-xs-top'],
          return: true,
        })
      } else if (response.data.message == 'Faulty data') {
        // Faulty Data
        oxgRemoveUfsFromContainer(modalResponseContainer)
        oxgCreateUf({
          format: 'box',
          icon: 'exclamation-mark--circled',
          style: 'danger',
          message: 'Error. Team name, Team slug or user id not found.',
          messageDe: 'Fehler. Team Name, Team Slug oder User ID nicht gefunden.',
          container: modalResponseContainer,
          classes: ['m-bottom', 'm-xs-top'],
          return: true,
        })
      } else if (response.data.message == 'Database error') {
        // Database error
        oxgRemoveUfsFromContainer(modalResponseContainer)
        oxgCreateUf({
          format: 'box',
          icon: 'exclamation-mark--circled',
          style: 'danger',
          message: 'Database error while trying to save',
          messageDe: 'Datenbank Fehler beim Speicherversuch',
          container: modalResponseContainer,
          classes: ['m-bottom', 'm-xs-top'],
          return: true,
        })
      }
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
    }
  });

}

window.oxgAddNewTeamModalOpen = (modalId)=> {
  console.log(modalId)
  let modal = document.getElementById('oxg-modal-' + modalId)
  let form = modal.querySelector('form')
  let formParent = form.parentNode
  let formClone = form.cloneNode(true)
  form.remove()
  formClone.classList.add('is-clone')
  formParent.appendChild(formClone)
  let nameField = modal.querySelector('#field-team-name')
  let slugField = modal.querySelector('#field-team-slug')
  let slugFieldManualEdit = false
  if(nameField && nameField.tagName == 'INPUT') nameField.focus()
  nameField.addEventListener('keyup', ()=> {
    if(!slugFieldManualEdit) {
      slugField.value = oxgSlugifyString(nameField.value)
    }
  })
  slugField.addEventListener('keyup', ()=> {
    if (slugField.value) {
      slugFieldManualEdit = true
      slugField.value = oxgSlugifyStringNoEndTrim(slugField.value)
    } else {
      slugFieldManualEdit = false
      slugField.value = nameField.value ? oxgSlugifyString(nameField.value) : null;
    }
  })
}

window.oxgWatchUserRoleSelection = (modalId)=> {
  let modal = document.getElementById('oxg-modal-' + modalId)
  let form = modal.querySelector('#edit-user-form')
  let formClone = form.cloneNode(true)
  let formParent = form.parentNode
  form.remove()
  formClone.classList.add('is-clone')
  formParent.appendChild(formClone)
  let userRoleMenu = modal.querySelector('#menu-user-role')
  let userClientMenu = modal.querySelector('#menu-user-client-container')
  let noClientMenu = modal.querySelector('#no-menu-user-client-info')
  let userClientMenuOptions = userClientMenu.querySelectorAll('option')
  console.log(userClientMenuOptions)
  userRoleMenu.addEventListener('change', ()=> {
    if (userRoleMenu.value == 'client') {
      userClientMenu.classList.remove('is-hidden')
      noClientMenu.classList.add('is-hidden')
    } else {
      userClientMenu.classList.add('is-hidden')
      noClientMenu.classList.remove('is-hidden')
      Array.from(userClientMenuOptions).forEach(option => {
        console.log(option)
        if (option.value == 0) {
          option.selected = true
        } else {
          option.selected = false
        }
      })
    }
  })
}

window.oxgWatchUserTeamRoleSelection = (modalId)=> {
  let modal = document.getElementById('oxg-modal-' + modalId)
  let form = modal.querySelector('#edit-user-team-role-form')
  let formClone = form.cloneNode(true)
  let formParent = form.parentNode
  form.remove()
  formClone.classList.add('is-clone')
  formParent.appendChild(formClone)
  let userRoleMenu = modal.querySelector('#menu-user-team-role')
  console.log(userRoleMenu)
  let userRoleMenuOptions = userRoleMenu.querySelectorAll('option')
  let memberRoleInfoContianer = modal.querySelector('#member-infos-container')
  let memberRoleInfos = memberRoleInfoContianer.querySelectorAll('.info-text')
  userRoleMenu.addEventListener('change', ()=> {
    let selectedValue = null;
    Array.from(userRoleMenuOptions).forEach(option => {
      if( option.selected ) {
        console.log('option.value: ', option.value)
        selectedValue = option.value
      }
    })
    Array.from(memberRoleInfos).forEach(info => {
      let forRole = info.getAttribute('data-team-role')
      console.log('forRole: ', forRole)
      if (forRole == selectedValue) { info.classList.remove('is-hidden') } else { info.classList.add('is-hidden') }
    })
  })
}

const mainContentUfMessageMaybe = ()=> {
  let ufMessage = oxgUrlParams.get('uf') 
  let ufMessageType = oxgUrlParams.get('ufmt')
  oxgRemoveUrlParams(['uf', 'ufmt'])
  console.log('typeof uf', typeof uf)
  if(ufMessage && typeof ufMessage != 'undefined') {
    let style = 'info'
    if(ufMessageType) {
      style = ufMessageType
    }
    let uf = oxgCreateUf({
      message: ufMessage,
      messageDe: ufMessage,
      icon: 'info-circled',
      style: style,
      container: document.getElementById('main-content-user-feedeback-container'),
      classes: ['p-s', 'm-s-bottom'],
      signal: 'false',
      format: 'box',
      return: true,
    })
    if (uf) {
      setTimeout(()=> {
        uf.remove()
      }, 3000)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (document.body.classList.contains('team')) {
    mainContentUfMessageMaybe()
  }

  if (document.body.classList.contains('manage-users')) {
    mainContentUfMessageMaybe()
    //initManageUsers()
  }

})